import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { isPlatformRole } from "@/types/firestore";

export function RoleRedirect() {
  const { user, role, isImpersonating, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-white">
        <div className="font-body text-text-muted">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (isImpersonating) {
    return <Navigate to="/org" replace />;
  }

  if (role && isPlatformRole(role)) {
    return <Navigate to="/admin" replace />;
  }

  if (role === "ORG_OWNER" || role === "ORG_ADMIN") {
    return <Navigate to="/org" replace />;
  }

  if (role === "ORG_REQUESTER") return <Navigate to="/org/support" replace />;

  return <Navigate to="/login" replace />;
}
